import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen__165_credit_note: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Credit note",
        "style": {},
        "childComponents": [
            {
                "componentType": "group",
                "style": {
                    "direction": "row",
                    "padding": 0,
                    "marginBottom": 10
                }
            },
            {
                "componentType": "form",
                "Name": "credit_note_add",
                "TableName": "vouchers",
                "Plugins": [
                    {
                        "type": "api",
                        "module": "all"
                    }
                ],
                "DisplayName": "vouchers",
                "columnNumber": "m1 t1 w1",
                "style": {
                    "padding": 16,
                    "backgroundColor": "#ffffff",
                    "direction": "column",
                    "borderRadius": 12
                },
                "Fields": [
                    {
                        "componentType": "fieldGroup",
                        "Label": "Credit note details",
                        "BindValue": "credit_note_details",
                        "style": {
                            "direction": "column"
                        },
                        "childComponents": [
                            {
                                "IncludeLabel": true,
                                "Label": "Voucher No.",
                                "PlaceHolder": "Will be auto generated...",
                                "IsMandatory": false,
                                "BindValue": "txt_voucher_no",
                                "Json_Attribute": "voucher_no",
                                "componentType": "textField",
                                "showInSummary": false,
                                "AutoPopulate": true,
                                "IsReadOnly": true,
                                "AutoPopulate_format": "CRN_[******]",
                                "IsVerticalView": true,
                                "inputType": "text"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Customer name",
                                "PlaceHolder": "",
                                "IsMandatory": true,
                                "BindValue": "drp_customer",
                                "Json_Attribute": "customer_id",
                                "componentType": "searchableDropdown",
                                "showInSummary": true,
                                "LookupName": "customers_with_due_from_transaction",
                                "IsVerticalView": true,
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Customer name is required"
                                    }
                                ]
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Jobcard No.",
                                "BindValue": "job_card_id",
                                "Json_Attribute": "job_card_id",
                                "componentType": "searchableDropdown",
                                "LookupName": "voucher_jobcard",
                                "IsMandatory": false,
                                "showInSummary": true,
                                "IsVerticalView": true
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Voucher date",
                                "IsMandatory": true,
                                "BindValue": "txt_voucher_date",
                                "Json_Attribute": "voucher_date",
                                "componentType": "dateField",
                                "showInSummary": true,
                                "IsVerticalView": true,
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Voucher date is required"
                                    }
                                ]
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Remarks",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_remarks",
                                "Json_Attribute": "narration",
                                "componentType": "textField",
                                "showInSummary": true,
                                "IsVerticalView": true,
                                "inputType": "text"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Ref No.",
                                "PlaceHolder": "Ref No.",
                                "IsMandatory": false,
                                "BindValue": "txt_Ref_no",
                                "Json_Attribute": "ref_no",
                                "componentType": "textField",
                                "showInSummary": true,
                                "IsVerticalView": true,
                                "inputType": "text"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Voucher type",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_voucher_type_",
                                "Json_Attribute": "voucher_type",
                                "componentType": "textField",
                                "showInSummary": true,
                                "Default_Value": "CreditNote",
                                "IsReadOnly": true,
                                "IsVerticalView": true,
                                "inputType": "text"
                            }
                        ]
                    },
                    {
                        "componentType": "subModule",
                        "name": "invoice_recivebles",
                        "label": "Invoice details",
                        "tableName": "invoice_recivebles_split",
                        "BindValue": "invoice_recivebles_split",
                        "LookupName": "customer_invoice_details_credit_note",
                        "parentField": "drp_customer",
                        "EnableAddActionForSubModule": false,
                        "DisableAddNewRow": true,
                        "DisableAddNewButton": true,
                        "NotAllowEmpty": true,
                        "childControls": [
                            {
                                "IncludeLabel": true,
                                "Label": "Invoice No.",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_invoice_no",
                                "Json_Attribute": "invoice_no",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ControlWidth": "200px"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Total amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_total_amount",
                                "Json_Attribute": "total_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "Default_Value": "0",
                                "inputType": "number"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Amount paid",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_paid_amount",
                                "Json_Attribute": "amount_paid",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "Default_Value": "0",
                                "inputType": "number"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Discount amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_discount_amount",
                                "Json_Attribute": "discounted_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "Default_Value": "0",
                                "inputType": "number"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Due amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_due_amount",
                                "Json_Attribute": "due_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[txt_total_amount] - [txt_paid_amount] - [txt_discount_amount]",
                                "Default_Value": "0",
                                "inputType": "number"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_amount",
                                "Json_Attribute": "amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": false,
                                "Default_Value": "0",
                                "inputType": "number"
                            },
                        ],
                        "FooterControls": [
                            {
                                "componentType": "textField",
                                "BindValue": "footer_col_1",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": { "display": "none" }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "footer_col_2",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": { "display": "none" }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "footer_col_3",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": { "display": "none" }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "footer_col_4",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": { "display": "none" }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "footer_col_5",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": { "display": "none" }
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "Net Amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_net_amount",
                                "Json_Attribute": "net_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_amount]",
                                "Default_Value": "0",
                                "inputType": "number",
                                "ControlWidth": "120px"
                            }
                        ]
                    },
                    {
                        "componentType": "subModule",
                        "name": "voucher_details",
                        "label": "Voucher details",
                        "tableName": "voucher_details",
                        "BindValue": "voucher_details",
                        "LookupName": "credit_note_ledgers_with_parent_id",
                        "parentField": "drp_customer",
                        "EnableAddActionForSubModule": false,
                        "DisableAddNewRow": true,
                        "DisableAddNewButton": true,
                        "NotAllowEmpty": true,
                        "childControls": [
                            {
                                "IncludeLabel": true,
                                "Label": "Ledger",
                                "PlaceHolder": "",
                                "IsMandatory": true,
                                "BindValue": "drp_ledger",
                                "Json_Attribute": "ledger_id",
                                "componentType": "searchableDropdown",
                                "IsVerticalView": true,
                                "showInSummary": false,
                                "IsReadOnly": false,
                                "LookupName": "credit_note_ledgers",
                                "EnableEditForControl": false,
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Ledger is required"
                                    }
                                ]
                            },
                             {
                                "IncludeLabel": true,
                                "Label": "Description",
                                "PlaceHolder": "",
                                "IsMandatory": true,
                                "BindValue": "txt_remarks",
                                "Json_Attribute": "remarks",
                                "componentType": "textField",
                                "showInSummary": true,
                                "IsVerticalView": false,
                                "inputType": "text",
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Description is required"
                                    }
                                ]
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_credit",
                                "Json_Attribute": "credit",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": false,
                                "Default_Value": "0",
                                "inputType": "number"
                            }
                           
                        ],
                        "FooterControls": [
                            {
                                "componentType": "textField",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "textField",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "Total credit",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_total_credit",
                                "Json_Attribute": "total_credit",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_credit]",
                                "Default_Value": "0",
                                "inputType": "number",
                                "validation": [
                                    {
                                        "rule": "pattern",
                                        "message": "The allocated amount should be equal to the credit note amount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "componentType": "group",
                        "style": {
                            "direction": "row",
                            "justifyContent": "flex-end",
                            "gap": 12,
                            "marginTop": 20
                        },
                        "childComponents": [
                            {
                                "componentType": "button",
                                "name": "Submit",
                                "Label": "Submit",
                                "onPressAction": "save",
                                "style": {
                                    "backgroundColor": "#22c55e",
                                    "textColor": "#FFFFFF",
                                    "padding": "10px 24px",
                                    "borderRadius": 8,
                                    "fontWeight": "600"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

export const screen_165_credit_note = screen__165_credit_note;
